import React, { useContext, useState } from "react";
import { RolePermissions, PermissionContext } from "appContext";
import { ReactComponent as EditIcon } from "assets/img/svg/EditBlackIcon.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { pages } from "views/pages/manage/common/constant";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";


const ActionsCellComponent = ({
  params,
  handleEditClick,
  handleCancelClick,
  handleSaveClick,
  rowForm,
  isValid,
  disable
}) => {
  const userPermissions = RolePermissions(useContext(PermissionContext), pages['paymentCollectionMasterSdSequencing']['id'])
  return params.api.getRowMode(params?.id) === "view" ? (
    <>
      <div className="d-flex align-items-center">
      {/* checkPermission(userPermissions, 'U') && */}
        { <EditIcon onClick={() => handleEditClick(params)} />}
      </div>
    </>
  ) : (
    <div className="d-flex align-items-center">
      <AButton
        variant="primary_filled"
        // className="w-full"
        onClick={() => {
          handleSaveClick(params)
        }}
        disabled={disable}
      >
        Save
      </AButton>
      <AButton
        variant="danger_filled"
        className=""
        onClick={() => {
          handleCancelClick(params)
        }}
      >
        Discard
      </AButton>
    </div>
  );
};

export default ActionsCellComponent;
